(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/draw-card-container.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/draw-card-container.js');
"use strict";


const _svs$components$tipse = svs.components.tipsen.drawCard,
  DrawCardLarge = _svs$components$tipse.DrawCardLarge,
  DrawCardSmall = _svs$components$tipse.DrawCardSmall,
  DrawCardMini = _svs$components$tipse.DrawCardMini,
  DrawCardHorizontalListItem = _svs$components$tipse.DrawCardHorizontalListItem;
const useComposeDrawForDrawCard = svs.components.tipsen.drawCard.useComposeDrawForDrawCard;
const DRAW_CARD_VARIANTS = svs.components.tipsen.drawCard.constants.DRAW_CARD_VARIANTS;
const If = svs.components.lbUtils.reactConditionals.If;
const clx = svs.components.lbUtils.clx;
const productIds = svs.utils.products.productIds;
const _svs$components$lbUi$ = svs.components.lbUi.participants,
  ParticipantsNames = _svs$components$lbUi$.ParticipantsNames,
  DescriptionSize = _svs$components$lbUi$.constants.DescriptionSize;
const DrawCardContainer = _ref => {
  let branding = _ref.branding,
    cardClassName = _ref.cardClassName,
    containerClassName = _ref.containerClassName,
    countdownString = _ref.countdownString,
    currentDraw = _ref.currentDraw,
    drawCardVariant = _ref.drawCardVariant,
    _ref$isListItem = _ref.isListItem,
    isListItem = _ref$isListItem === void 0 ? false : _ref$isListItem,
    isSelected = _ref.isSelected,
    onToggleDrawSelector = _ref.onToggleDrawSelector,
    _ref$shouldShowChange = _ref.shouldShowChangeDrawButton,
    shouldShowChangeDrawButton = _ref$shouldShowChange === void 0 ? false : _ref$shouldShowChange;
  const blockName = 'pg_draw_card_container';
  const classNames = clx(blockName, containerClassName);
  const composedDraw = useComposeDrawForDrawCard(currentDraw);
  const title = composedDraw.competitionName ? composedDraw.competitionName : composedDraw.title;
  let titleElement = title;
  if (composedDraw.productId === productIds.MATCHEN) {
    var _composedDraw$betEven, _composedDraw$betEven2;
    const homeParticipant = (_composedDraw$betEven = composedDraw.betEvents[0]) === null || _composedDraw$betEven === void 0 ? void 0 : _composedDraw$betEven.homeParticipant;
    const awayParticipant = (_composedDraw$betEven2 = composedDraw.betEvents[0]) === null || _composedDraw$betEven2 === void 0 ? void 0 : _composedDraw$betEven2.awayParticipant;
    titleElement = React.createElement(ParticipantsNames, {
      awayParticipant: awayParticipant,
      homeParticipant: homeParticipant,
      nameSize: DescriptionSize.Full
    });
  }
  return React.createElement("div", {
    className: classNames
  }, React.createElement(If, {
    condition: drawCardVariant === DRAW_CARD_VARIANTS.LARGE
  }, React.createElement(DrawCardLarge, {
    betEvents: composedDraw.betEvents,
    branding: branding,
    competitionDrawNumber: composedDraw.competitionDrawNumber,
    currentDraw: currentDraw,
    extraMoney: composedDraw.extraMoney,
    icon: composedDraw.icon,
    isListItem: isListItem,
    league: composedDraw.league,
    netSale: composedDraw.netSale,
    onToggleDrawSelector: onToggleDrawSelector,
    regCloseTime: composedDraw.regCloseTime,
    shouldShowChangeDrawButton: shouldShowChangeDrawButton,
    state: composedDraw.state,
    titleElement: titleElement,
    uniqueId: composedDraw.drawId
  })), React.createElement(If, {
    condition: !isListItem && drawCardVariant === DRAW_CARD_VARIANTS.SMALL
  }, React.createElement(DrawCardSmall, {
    betEvents: composedDraw.betEvents,
    branding: branding,
    competitionDrawNumber: composedDraw.competitionDrawNumber,
    currentDraw: currentDraw,
    extraMoney: composedDraw.extraMoney,
    icon: composedDraw.icon,
    league: composedDraw.league,
    netSale: composedDraw.netSale,
    onToggleDrawSelector: onToggleDrawSelector,
    productId: composedDraw.productId,
    regCloseTime: composedDraw.regCloseTime,
    shouldShowChangeDrawButton: shouldShowChangeDrawButton,
    state: composedDraw.state,
    titleElement: titleElement,
    uniqueId: composedDraw.drawId
  })), React.createElement(If, {
    condition: drawCardVariant === DRAW_CARD_VARIANTS.MINI
  }, React.createElement(DrawCardMini, {
    branding: branding,
    competitionName: composedDraw.competitionName,
    currentDraw: currentDraw,
    extraMoney: composedDraw.extraMoney,
    icon: composedDraw.icon,
    league: composedDraw.league,
    netSale: composedDraw.netSale,
    regCloseTime: countdownString || composedDraw.regCloseTime,
    state: composedDraw.state,
    titleElement: composedDraw.title,
    uniqueId: composedDraw.drawId
  })), React.createElement(If, {
    condition: drawCardVariant === DRAW_CARD_VARIANTS.HORIZONTAL_LIST_ITEM
  }, React.createElement(DrawCardHorizontalListItem, {
    betEvents: composedDraw.betEvents,
    branding: branding,
    className: cardClassName,
    competitionDrawNumber: composedDraw.competitionDrawNumber,
    currentDraw: currentDraw,
    extraMoney: composedDraw.extraMoney,
    icon: composedDraw.icon,
    isListItem: isListItem,
    isSelected: isSelected,
    league: composedDraw.league,
    netSale: composedDraw.netSale,
    regCloseTime: composedDraw.regCloseTime,
    state: composedDraw.state,
    titleElement: titleElement,
    uniqueId: composedDraw.drawId
  })), React.createElement(If, {
    condition: isListItem && drawCardVariant === DRAW_CARD_VARIANTS.SMALL
  }, React.createElement(DrawCardSmall, {
    betEvents: composedDraw.betEvents,
    branding: branding,
    className: cardClassName,
    competitionDrawNumber: composedDraw.competitionDrawNumber,
    currentDraw: currentDraw,
    drawNumber: composedDraw.drawNumber,
    extraMoney: composedDraw.extraMoney,
    href: composedDraw.href,
    icon: composedDraw.icon,
    isDisabled: composedDraw.isDisabled,
    isListItem: true,
    isSelected: isSelected,
    league: composedDraw.league,
    netSale: composedDraw.netSale,
    onToggleDrawSelector: onToggleDrawSelector,
    participants: composedDraw.participants,
    productId: composedDraw.productId,
    regCloseTime: composedDraw.regCloseTime,
    state: composedDraw.state,
    titleElement: titleElement,
    uniqueId: composedDraw.drawId
  })));
};
setGlobal('svs.components.tipsen.drawCard.DrawCardContainer', DrawCardContainer);

 })(window);